export type CountdownTone = 'calm' | 'urgent' | 'waiting';

export type CountdownView = {
  tone: CountdownTone;
  /** WAITING 相位为 null —— 视觉规格 §6.2：**禁止任何倒计时数字**。 */
  clock: string | null;
};

/**
 * 最后 60 秒转红。
 *
 * <p>视觉规格 §6.3 原文写的是 30 秒，改成 60 秒是 2026-08-18 评审的决定
 * （`doc/design/MILHAR_ATMOSPHERE_SPEC.md` §5.1）。**改回 30 之前先看那一节** ——
 * 视觉规格那句尚未同步修订，照着它改会把这个决定悄悄回滚掉。
 */
const URGENT_SECONDS = 60;

/**
 * 封盘倒计时。
 *
 * <p>WAITING 相位只出 `SORTEANDO ···`，一个数字都不给：那段时间我们在等真实的
 * ETH 区块，长短不由我们决定，给出一个会走到 0 却还没开奖的秒数比不给更糟。
 *
 * <p>OPEN 相位即使时间已经走完也仍然显示 `0:00` 而不是负数或空 —— 相位由后端
 * 翻转，前端的钟和服务端总有几百毫秒的差，这个缝隙里不该闪出一个坏值。
 */
export function countdownView(
  endsAtSec: number,
  nowSec: number,
  phase: 'open' | 'waiting',
): CountdownView {
  if (phase === 'waiting') return { tone: 'waiting', clock: null };
  const left = Math.max(0, Math.floor(endsAtSec - nowSec));
  const minutes = Math.floor(left / 60);
  const seconds = left % 60;
  return {
    tone: left <= URGENT_SECONDS ? 'urgent' : 'calm',
    clock: `${minutes}:${String(seconds).padStart(2, '0')}`,
  };
}
